import React from "react";
import { Marquee } from "./ui/marquee";

const ImageMarquee = () => {
  const images = [
    "/ryota-logo-81b.jpg",
    "/uitools.jpg",
    "/ryota-logo-81b.jpg",
    "/rioair-f7e.jpg",
    "irven-aeb.jpg",
    "fortec-ee7.jpg",
  ];

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '40px auto',
      padding: '32px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #f0f0f0',
      boxSizing: 'border-box',
    }}>
      <div className="w-full">
        <Marquee pauseOnHover>
          {images.map((src, index) => (
              <div key={index} className="flex-shrink-0 mr-4 flex items-center">
                <img
                  src={src}
                  alt={`Logo ${index + 1}`}
                  className="h-20 w-auto object-contain rounded-md bg-white px-3 py-1 shadow-sm"
                  style={{ maxWidth: 160 }}
                />
              </div>
            ))}
        </Marquee>
      </div>
    </div>
  );
};

export default ImageMarquee;
